const translations = {
  title: 'Dynamic Service Orders',
  name: 'Name',
  checklist: 'Checklist',
  place: 'Place',
  cardsView: 'Cards view (coming soon)',
  selectPlace: 'Select a place',
  lockReasons: 'Lock reasons',
  successTitle: 'Activity answered successfully!',
  successBody: 'The answers have already been sent!'
}

export default translations
